import axios from 'utils/axios';

export const getSynchronisationLogs = async (data) => {
    const result = await axios.get('synchornisation-logs/', {
        params: data
    });
    return result.data;
};
